

let slideIndex = 1;
$('.next').click(function () {
  console.log(slideIndex);

  goToNextSlides(slideIndex)
  if (slideIndex < 6) {

    slideIndex++
  }
  // slideIndex++
  // tl7.play()
  // tl7.restart()
  // tl7.play()

})
$('.prev').click(function () {
  // tl7.pause()
  // tl8.play()
  // tl8.restart()
  // tl7.invalidate()
  goToPrevSlides(slideIndex)
  if (slideIndex > 1) {

    --slideIndex
  }

  console.log(slideIndex);
})
// alert(slideIndex)

const tlStart = new TimelineMax()
const tl = new TimelineMax({ paused: true })
const tl2 = new TimelineMax({ paused: true })
const tl4 = new TimelineMax({ paused: true })
const tl5 = new TimelineMax({ paused: true })
const tl6 = new TimelineMax({ paused: true })
const tl7 = new TimelineMax({ paused: true })
const tl8 = new TimelineMax({ paused: true })
const tl9 = new TimelineMax({ paused: true })
const tl10 = new TimelineMax({ paused: true })
const tl11 = new TimelineMax({ paused: true })
const tl12 = new TimelineMax({ paused: true })
const controller = new ScrollMagic.Controller()

const pack = $('.slide-pack')
tlStart
  .to('.product-top .slide01', 0.8,
    {
      y: 0,
      autoAlpha: 1
    })
  .to('.product-pack', 0.8,
    {
      y: 0,
      autoAlpha: 1
    }, '-=0.8')
tl
  .to('.product-top .slide01', 0.8,
    {
      y: '-100%',
      // autoAlpha: 0
    })
  .to('.product-top', 0.8,
    {
      height: '41vh'
    }, '-=0.8')
  .to('.product-top .slide02', 0.8,
    {
      y: '-68%',
      autoAlpha: 1
    }, '-=0.8')
  // .to('.product-bottom .slide01', 0.8,
  //   {
  //     // y: '-100%',
  //     autoAlpha: 0
  //   }, '-=0.8')

  .to('.product-pack', 0.8,
    {
      y: '10%',
    }, '-=0.8')
  .to('.pack-top', 0.4, {
    // autoAlpha: 0,
    //  transform: "rotate3d(-1, 1, 0, 0deg)"
    y: '-200%',
    autoAlpha: 0,
    ease: "Expo.easeInOut"
  }, '-=0.4')
  .to('.product-bottom .slide02 .container', 0.8,
    {
      y: '0',
      autoAlpha: 1
    }, '-=0.4')
  .to('.product-bottom .slide02 .title', 0.8,
    {
      y: '0',
      autoAlpha: 1
    }, '-=0.6')
  .to('.product-bottom .slide02 .slide-btn', 0.8,
    {
      y: '0',
      autoAlpha: 1
    }, '-=0.3')
tl2

  .to('.pack-nuts', 0.1, {
    delay: 0.7,
    autoAlpha: 1

  })
  .to('.pack-bah', 0.5, {
    // delay: 0.7,
    y: '-30%',
    // y: '-70%',
    // x: '-48%',
    x: '-50%',
    autoAlpha: 1,
    scale: 1.2,

  }, '-=0.4')
  .to('.pack-bah', 0.5, {
    autoAlpha: 0,

  }, '+=.6')
  .set('.pack-bah', {
    autoAlpha: 0,
    y: '-30%',
    x: '-50%',
    autoAlpha: 0,
    scale: 0.5,
  })

tl4
  .to('.product-top', 0.8,
    {
      height: '64vh'
    })
  .to('.product-bottom .slide02', 0.8,
    {
      height: '37vh'
    }, '-=0.8')
  .to('.product-bottom .slide02 .title', 0.8,
    {
      y: '-100%',
      autoAlpha: 0
    }, '-=0.8')
  .to('.product-pack', 0.8,
    {
      y: '60%',
    }, '-=0.8')
  .to('.product-top .slide02', 0.2,
    {
      // y: '-100%',
      autoAlpha: 0
    }, '-=0.8')
  .to('.product-top .slide03', 0.1,
    {
      // y: '0%',
      autoAlpha: 1
    }, '-=0.8')
  .to('.product-top .slide03 .container', 0.8,
    {
      y: '0',
      autoAlpha: 1
    }, '-=0.8')

// .to('.pack-bah', 0.5, {
//   autoAlpha: 0

// }, '-=0.4')
// .to('.product-bottom .slide02', 0.1,
// {
//   // y: '-100%',
//   autoAlpha: 0
// }, '-=0.8')

tl5

  .to('.product-top .slide03', 0.2,
    {
      y: '100%',
      autoAlpha: 0
    })
  .to('.product-top .slide04', 0.1,
    {
      y: '0%',
      autoAlpha: 1
    }, '-=0.2')
  .to('.product-top .slide04 .container', 0.8,
    {
      y: '0',
      autoAlpha: 1
    }, '-=0.1');



tl6
  // .set('.product-pack', {  y: '60%'})
  .to('.product-bottom .slide02', 0.5,
    {
      y: '100%',
      // autoAlpha: 0
    })
  .to('.product-top .slide04', 0.5,
    {
      y: '-100%',
      // autoAlpha: 0
    }, '-=0.5')
  .to('.product-bottom .slide04', .8,
    {
      autoAlpha: 1
    }, '-=0.5')
  .to('.product-bottom .slide04 .btns', .8,
    {
      autoAlpha: 1
    }, '-=0.1')
  .to('.pack-man', 0.1,
    {
      // y: '-100%',
      autoAlpha: 1
    }, '-=0.2')
  .to('.product-pack', 3.8,
    {

      y: '-80%',
      ease: Power4.easeOut
    }, '-=0.2')


tl7
  // .set('.footer', {y: '100%', autoAlpha: 0})
  .to('.footer', 0.8,
    {
      y: '0%',
      autoAlpha: 1
    })


tl8
.to('.product-pack', 1.8,
{

  y: '60%',
  ease: Power4.easeOut
})
.to('.pack-man', 0.1,
{
  // y: '-100%',
  autoAlpha: 0
})
.to('.product-bottom .slide04 .btns', .8,
{
  autoAlpha: 0
}, '-=0.8')
.to('.product-top .slide04', 0.5,
{
  y: '0%',
  // autoAlpha: 0
}, '-=1.2')
.to('.product-bottom .slide02', 0.5,
{
  y: '0%',
  // autoAlpha: 0
}, '-=1.2')

.to('.product-bottom .slide04', .1,
{
  autoAlpha: 0
}, '-=0.5')




function goToNextSlides(slideIndex) {
  switch (slideIndex) {
    case 1:
      tl.restart()
      tl2.restart();
      $('.pack-nuts img').each(function () {
        let tl3 = new TimelineMax()
        let controller = new ScrollMagic.Controller()
        let top = $(this).data('top') || 0;
        let side = $(this).data('left') || 0;

        tl3

          .to(this, 1.4, {
            delay: .3,
            top: `-=${top}`,
            left: `-=${side}`,
            ease: "Power2.easeOut"
          })
          .to(this, .4, {
            autoAlpha: 0

          })

      })
      break;
    case 2:
      tl4.restart()

      break;
    case 3:
      tl5.restart()
      break;

    case 4:
      tl6.restart()
      break;

    case 5:
      // console.log(' case 5 next / show footer footer; slideIndex = ' + slideIndex);
      // alert(slideIndex)
      tl7.restart()


      break;
  }
}
function goToPrevSlides(slideIndex) {
  switch (slideIndex) {
    case 6:
      //hide footer
      tl7.reverse()
      break;
    case 5:
      //hide superman
      // tl6.reverse()
      tl8.restart()
      break;
    case 4:
      //hide superman
      tl5.reverse()
      break;
    case 3:
      //hide superman
      tl4.reverse()
      break;
    case 2:
      //hide superman
      // tl2.reverse()
      tl.reverse()
      $('.pack-nuts img').each(function () {
        let tl10 = new TimelineMax()
        let controller = new ScrollMagic.Controller()
        // let top = $(this).data('top') || 0;
        let side = $(this).data('orig') || 0;

        tl10

          .set(this, {
            top: `9%`,
            left: `${side}`,
            autoAlpha: 1
          })

      })
      break;

  }
}



// let el = $('window');
let lastAnimation = new Date().getTime();
let quietPeriod = 500;
let animationTime = 1000;
function swipeEvents(el) {

  return el.each(function () {

    let startX,
      startY,
      $this = $(this);

    $this.bind('touchstart', touchstart);

    function touchstart(event) {
      let touches = event.originalEvent.touches;
      if (touches && touches.length) {
        startX = touches[0].pageX;
        startY = touches[0].pageY;
        $this.bind('touchmove', touchmove);
      }
      event.preventDefault();
    }

    function touchmove(event) {
      let touches = event.originalEvent.touches;
      if (touches && touches.length) {
        let deltaX = startX - touches[0].pageX;
        let deltaY = startY - touches[0].pageY;
        if (deltaY >= 50) {
          $this.trigger("swipeUp");
          goToNextSlides(slideIndex)
          if (slideIndex < 6) {
            slideIndex++
          } else {
            const href = $('body').data('next')
            window.location.href = `/${href}.html`;
            slideIndex = 1
            tlStart.restart()
          }
        }
        if (deltaY <= -50) {
          $this.trigger("swipeDown");
          goToPrevSlides(slideIndex)
          console.log('slideIndex' + slideIndex);
          if (slideIndex > 1) {

            --slideIndex
          }
        }
        if (Math.abs(deltaX) >= 50 || Math.abs(deltaY) >= 50) {
          $this.unbind('touchmove', touchmove);
          console.log('touchmove');
        }
      }
      event.preventDefault();
    }

  });
};

swipeEvents($(window))

function initScroll(event, delta) {
  let deltaOfInterest = delta;
  let timeNow = new Date().getTime();
  // Cancel scroll if currently animating or within quiet period
  if (timeNow - lastAnimation < quietPeriod + animationTime) {
    event.preventDefault();
    return;
  }

  if (deltaOfInterest < 0) {
    goToNextSlides(slideIndex)
    if (slideIndex < 6) {
      slideIndex++
    } else {
      const href = $('body').data('next')
      window.location.href = `/${href}.html`;
      slideIndex = 1
      tlStart.restart()
    }
  } else {


    goToPrevSlides(slideIndex)
    console.log('slideIndex' + slideIndex);
    if (slideIndex > 1) {

      --slideIndex
    }
  }
  lastAnimation = timeNow;
}

$(window).on('load', function () {
  $(document).bind('mousewheel DOMMouseScroll', function (event) {
    event.preventDefault();
    setTimeout(() => {
      let delta = event.originalEvent.wheelDelta || -event.originalEvent.detail;
      initScroll(event, delta);
    }, 500)

  });
});
